<div class="dialog-content">
  <h1 mat-dialog-title>{{ 'common.button.edit' | translate }}</h1>
  <div mat-dialog-content>
    <form *ngIf="editForm" [formGroup]="editForm">
      <ui-chip-field
        [formControl]="editForm.get('deliveryNotes')"
        [label]="'common.field.deliveryNoteNumbers' | translate"
        [hasErrorMessageContainer]="true"
      ></ui-chip-field>
      <ui-chip-field
        [formControl]="editForm.get('invoices')"
        [label]="'common.field.invoices' | translate"
        [hasErrorMessageContainer]="true"
        [testId]="'invoices'"
      ></ui-chip-field>
      <ui-chip-field
        [formControl]="editForm.get('purchaseOrders')"
        [label]="'common.field.purchaseOrderNumbers' | translate"
        [hasErrorMessageContainer]="true"
      ></ui-chip-field>
    </form>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      [text]="'common.button.save' | translate"
      [testId]="'waybill-edit-button'"
      [type]="buttonType.Primary"
      [disabled]="editForm.invalid"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>
